import { api } from './base';

import { MutationArg } from 'v2/types';
import { SpecialDropSettingsModel, SpecialDropSettingsRequest } from 'v2/types/SpecialDropSettingsModel';
import { SpinBannerSettingsModel, SpinBannerSettingsRequest } from 'v2/types/SpinBannerSettingsModel';

const SPIN_BANNER_SETTINGS_URL = 'v1/admin/spin-banner-settings';
const SPECIAL_DROP_SETTINGS_URL = 'admin/special-drop/settings';

export const spinBannerService = {
  getSpinBannerSettings(): Promise<SpinBannerSettingsModel> {
    return api.get(SPIN_BANNER_SETTINGS_URL).json();
  },

  updateSpinBannerSettings(
    _key: string,
    { arg }: MutationArg<SpinBannerSettingsRequest>
  ): Promise<SpinBannerSettingsModel> {
    return api.put(SPIN_BANNER_SETTINGS_URL, { json: arg }).json();
  },

  getSpecialDropSettings(): Promise<SpecialDropSettingsModel> {
    return api.get(SPECIAL_DROP_SETTINGS_URL).json();
  },

  updateSpecialDropSettings(
    _key: string,
    { arg }: MutationArg<SpecialDropSettingsRequest>
  ): Promise<SpecialDropSettingsModel> {
    return api.put(SPECIAL_DROP_SETTINGS_URL, { json: arg }).json();
  },
};
